function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export var DriverType;
(function (DriverType) {
  DriverType["LOCALSTORAGE"] = "localStorage";
  DriverType["SESSIONSTORAGE"] = "sessionStorage";
})(DriverType || (DriverType = {}));
const driverType = {
  LOCALSTORAGE: 'localStorage',
  SESSIONSTORAGE: 'sessionStorage'
};
const defaultConfig = {
  name: 'domain',
  driver: driverType.LOCALSTORAGE
};
function createInstance(options) {
  const config = _objectSpread(_objectSpread({}, defaultConfig), options);
  let storage = {};
  try {
    storage = typeof window === 'undefined' ? {} : window[config.driver];
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(config.driver, err);
    }
  }
  if (config.name.indexOf('/') >= 0) {
    throw new Error('the slash (/) is an illegal character for option.name');
  }
  config.prefix = "".concat(config.name, "/");
  return {
    storage,
    getItem(key) {
      let result;
      try {
        result = this.storage.getItem("".concat(config.prefix).concat(key));
      } catch (err) {
        result = null;
      }
      if (result) {
        result = JSON.parse(result);
      }
      return result;
    },
    setItem(key, value, onError) {
      try {
        this.storage.setItem("".concat(config.prefix).concat(key), JSON.stringify(value));
      } catch (err) {
        console.error(config.driver, err);
        onError === null || onError === void 0 ? void 0 : onError(err);
      }
    },
    hasItem(key) {
      let result;
      try {
        var _this$storage$getItem, _this$storage;
        result = (_this$storage$getItem = (_this$storage = this.storage).getItem) === null || _this$storage$getItem === void 0 ? void 0 : _this$storage$getItem.call(_this$storage, "".concat(config.prefix).concat(key));
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(config.driver, err);
        }
      }
      return result !== null;
    },
    removeItem: function removeItem(key) {
      try {
        this.storage.removeItem("".concat(config.prefix).concat(key));
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(config.driver, err);
        }
      }
    },
    clear() {
      let index;
      let key;
      try {
        for (index = this.storage.length - 1; index >= 0; index--) {
          var _key;
          key = this.storage.key(index);
          if (((_key = key) === null || _key === void 0 ? void 0 : _key.indexOf(config.prefix)) === 0) {
            this.storage.removeItem(key);
          }
        }
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(config.driver, err);
        }
      }
    },
    length() {
      return this.keys().length;
    },
    keys() {
      let index;
      let key;
      const keys = [];
      try {
        for (index = 0; index < this.storage.length; index++) {
          var _key2;
          key = this.storage.key(index);
          if (((_key2 = key) === null || _key2 === void 0 ? void 0 : _key2.indexOf(config.prefix)) === 0) {
            keys.push(key.substring(config.prefix.length));
          }
        }
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(config.driver, err);
        }
      }
      return keys;
    }
  };
}
export default Object.assign(createInstance, _objectSpread({}, driverType));